import img_meet_hack from "../../../img/profile/achievement/meet_hack.png"
import img_okashi_omikuzi from "../../../img/profile/achievement/okashi_omikuzi.png"
import img_tiqa from "../../../img/profile/achievement/tiqa.png"
import img_engineer_tree from "../../../img/profile/achievement/engineer_tree.png"
import img_gijutucom from "../../../img/profile/achievement/gijutucom.png"
import img_dita from "../../../img/profile/achievement/dita.png"
import img_meethack_geekten from "../../../img/profile/achievement/meethack_geekten.png"
import img_nomipara from "../../../img/profile/achievement/nomipara.png"
import img_nomipara2 from "../../../img/profile/achievement/nomipara2.png"
import img_reiko from "../../../img/profile/achievement/reiko.png"
import img_jphacks from "../../../img/profile/achievement/jphacks2022.jpg"
import img_schema from "../../../img/profile/achievement/schema.png"
import img_miyagi from "../../../img/profile/achievement/miyagi.png"
import img_pioneer from "../../../img/profile/achievement/pioneer.png"

const data = {
    "achievement":[
        {
            "date":"2025/11",
            "name":"✨JPHACKS2025 審査員",
            "img":img_jphacks ,
            "about":"審査員としてJPHACKSに参加しました。",
            "article":"https://jphacks.com/2025/committee-members/",
            "github":""
        },
        {
            "date":"2024/7",
            "name":"🏆 IVS LAUNCHPAD 登壇 (AI VOLT)",
            "img":"",
            "about":"AI VOLTの軍神がLAUNCHPADにて登壇しました",
            "article":"",
            "github":""
        },
        {
            "date":"2024/2",
            "name":"🏆 Qiitaハッカソン 予選入賞 & 決勝出場",
            "img":"",
            "about":"",
            "article":"",
            "github":""
        },
        {
            "date":"2023/11",
            "name":"✨JPHACKS2023 ゲスト審査員",
            "img":img_jphacks ,
            "about":"ゲスト審査員としてJPHACKSに参加しました。",
            "article":"https://jphacks.com/2023/detail/",
            "github":""
        },
        {
            "date":"2023/3",
            "name":"💪みやぎハッカソン 2022 / 出場",
            "img":img_miyagi,
            "about":"",
            "article":"",
            "github":""
        },
        {
            "date":"2023/3",
            "name":"✨関西ビギナーズハッカソン vol.1 審査員",
            "img":"",
            "about":"関西ビギナーズハッカソンの審査員として参加しました。",
            "article":"",
            "github":""
        },
        {
            "date":"2023/1",
            "name":"👑Google Cloud Challenge 2022 すきーま / 最優秀賞, ファイナリスト賞",
            "img":img_schema,
            "about":"隙間時間を有効活用できるサービスです / バックエンド、インフラ、Ops、デザイン担当",
            "article":"",
            "github":"https://github.com/Doer-org/google-cloud-challenge-2022"
        },
        {
            "date":"2022/11",
            "name":"👑JPHACKS2022 のみぱら! / Audience 2位, 審査委員特別賞, Innovator認定, Award Day Sponsor Award (サントリー賞, シグマ賞, Jストリーム 賞)",
            "img":img_nomipara2,
            "about":"オンライン飲み会に最適化された新しいビデオ通話サービスです / バックエンド、インフラ、Ops、デザイン担当",
            "article":"",
            "github":"https://github.com/jphacks/F_2205"
        },
        {
            "date":"2022/10",
            "name":"👑JPHACKS2022 のみぱら / Best Hacking Sprint Award(Fブロック1位), Hacking Sprint Block Sponsor Award(シグマ賞), Finalist Award",
            "img":img_nomipara,
            "about":"オンライン飲み会に最適化された新しいビデオ通話サービスです / バックエンド、インフラ、Ops担当 / 「JPHACKS 2022 Award Day」進出チームに選ばれました",
            "article":"",
            "github":"https://github.com/jphacks/F_2205"
        },
        {
            "date":"2022/9",
            "name":"🏆技育展2022 MeetHack / 優秀賞",
            "img":img_meethack_geekten,
            "about":"交流会を最初から最後までサポートするアプリ 『Meet Hack』/ バックエンド、インフラ、Ops担当",
            "article":"",
            "github":"https://github.com/Doer-org/hack-camp_vol5_2022"
        },
        {
            "date":"2022/9",
            "name":"💪技育展2022 DITA / 登壇",
            "img":img_dita,
            "about":"技術×おみくじをテーマにした 『DITA』/ バックエンド、インフラ、デプロイ担当",
            "article":"",
            "github":"https://github.com/Doer-org/geekten_vol4_2022"
        },
        {
            "date":"2022/9",
            "name":"🏆sansan Trigger2022 / 2位",
            "img":img_gijutucom,
            "about":"技術書を手軽に入手できるプラットフォーム 『技術書.com』/ フロント担当",
            "article":"",
            "github":""
        },
        {
            "date":"2022/8",
            "name":"🏆SPAJAM2022 第一回予選 / 優秀賞",
            "img":img_reiko,
            "about":"超短期間で、最高にキンキンに冷えた飲み物を準備できるアプリ / フロント担当",
            "article":"",
            "github":"https://github.com/mahiro72/SPAJAM2022"
        },
        {
            "date":"2022/7",
            "name":"👑技育CAMP vol.5 / 最優秀賞",
            "img":img_meet_hack,
            "about":"交流会を最初から最後までサポートするアプリ 『Meet Hack』 / バックエンド、インフラ、フロントのロジック、デザインなど担当",
            "article":"https://note.com/sino_72/n/n5b8cd460da5c",
            "github":"https://github.com/Doer-org/hack-camp_vol5_2022"
        },
        {
            "date":"2022/6",
            "name":"🏆技育CAMP vol.4 / 努力賞",
            "img":img_okashi_omikuzi,
            "about":"おかし×おみくじをテーマにしたアプリ 『Okashi Omikuzi』/ バックエンド、インフラ、フロントのロジックを少し",
            "article":"https://note.com/sino_72/n/n7102ad343284",
            "github":"https://github.com/Doer-org/hack-camp_vol4_2022"
        },
        {
            "date":"2022/4",
            "name":"👑42HoursTuningTheBackend / 1位",
            "img":"",
            "about":"バックエンドのパフォーマンスチューニングコンテスト / SQLの高速化を担当(インデックス、N+1問題など)",
            "article":"",
            "github":"https://github.com/mahiro72/42HoursTuningTheBackend"
        },
        {
            "date":"2022/3",
            "name":"🏆令和3年度データ解析コンペティション / コネヒト賞",
            "img":"",
            "about":"新生児・乳幼児の母親をメインユーザとするポータルサイトのデータの解析コンペティション",
            "article":"",
            "github":""
        },
        {
            "date":"2022/2",
            "name":"👑データ解析コンペティション関西予選 / 最優秀賞",
            "img":"",
            "about":"新生児・乳幼児の母親をメインユーザとするポータルサイトのデータの解析コンペティション",
            "article":"",
            "github":""
        }, 
        {
            "date":"2022/2",
            "name":"💪Pioneer hackathon 2022 / 3位",
            "img":img_pioneer,
            "about":"2daysハッカソン / フロントエンド担当",
            "article":"https://note.jpn.pioneer/n/n0c5ea0491f68",
            "github":""
        }, 
        {
            "date":"2022/1",
            "name":"🏆技育CAMP vol.13 / 努力賞",
            "img":img_tiqa,
            "about":"エンジニア向け掲示板 『Tiqa (ティッカ)』 / バックエンド担当",
            "article":"",
            "github":"https://github.com/Doer-org/hack-camp_vol13_server"
        },
        {
            "date":"2021/11",
            "name":"👑技育CAMP vol.11 / 最優秀賞",
            "img":img_engineer_tree,
            "about":"プログラミングの勉強時間と比例して木が成長するアプリ 『Engineer Tree』 / フロント、バックエンド、インフラ担当",
            "article":"",
            "github":"https://github.com/Doer-org/hack-camp_vol13_server"
        },
    ]
}

export default data;